The city or suburb of the address.
